import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { usePosts } from "@/lib/posts";
import { ArrowRight } from "lucide-react";

export default function BlogPreview() {
    const posts = usePosts(3);
    return (
        <section
            data-testid="blog-preview-section"
            className="relative py-24 bg-[#0A0A0B] border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14">
                    <div>
                        <p className="overline">Nyheter & insikter</p>
                        <h2 className="mt-4 font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
                            Aktuellt{" "}
                            <span className="italic text-[#C4A977]">
                                från byrån
                            </span>
                        </h2>
                    </div>
                    <Link
                        to="/nyheter"
                        data-testid="blog-see-all"
                        className="inline-flex items-center gap-2 text-[#C4A977] hover:text-[#DBC08F] text-sm group whitespace-nowrap"
                    >
                        Se alla nyheter
                        <ArrowRight
                            size={14}
                            className="transition-transform duration-300 group-hover:translate-x-1"
                        />
                    </Link>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {posts.map((p, i) => (
                        <motion.article
                            key={p.slug}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.7, delay: i * 0.1 }}
                            className="group"
                        >
                            <Link
                                to={`/nyheter/${p.slug}`}
                                data-testid={`blog-card-${p.slug}`}
                                className="block h-full bg-[#111113] border border-white/5 hover:border-[#C4A977]/40 p-8 rounded-sm transition-colors duration-500"
                            >
                                <div className="flex items-center gap-3 text-xs text-[#A1A1AA] uppercase tracking-widest">
                                    <span className="text-[#C4A977]">
                                        {p.category}
                                    </span>
                                    <span className="w-1 h-1 bg-white/20 rounded-full" />
                                    <span>{p.date}</span>
                                </div>
                                <h3 className="mt-5 font-serif text-2xl text-[#F4F4F5] group-hover:text-[#C4A977] leading-tight transition-colors duration-500">
                                    {p.title}
                                </h3>
                                <p className="mt-4 text-[#A1A1AA] text-sm leading-relaxed">
                                    {p.excerpt}
                                </p>
                                <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#C4A977]">
                                    Läs artikel
                                    <ArrowRight
                                        size={14}
                                        className="transition-transform duration-300 group-hover:translate-x-1"
                                    />
                                </div>
                            </Link>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
